<template>
  <div class="header z-flex z-flex-between">
    <div class="header-l z-flex">
      <img class="logo" @click="toUrl('/index')" src="../assets/images/logo.png"/>
      <div class="nav z-flex">
        <div 
          :class="['item',activeNav == item.name ? 'active' : '']" 
          v-for="(item,index) in navList" 
          :key="index" 
          @click="toUrl(item.url)"
        >
        {{item.title}}
        </div>
      </div>
    </div>
    <div class="header-r">
      <el-popover
        popper-class="my-menu"
        placement="bottom-end"
        trigger="hover"
         v-if="isLogin"
      >
        <div class="user z-flex" slot="reference">
          <el-image fit="cover" class="avatar" :src="this.vuex_user.avatar || require('../assets/images/avatar.png')"></el-image>
          <div class="username">{{this.vuex_user.username}}</div>
          <i class="el-icon-caret-bottom"></i>
        </div>
        <div class="menu-list">
          <div class="item z-flex" @click="toUrl('/my/gallery')">
            <i class="el-icon-camera"></i>
            <span class="text">我的图库</span>
          </div>
          <div class="item z-flex" @click="toUrl('/my/awards')">
            <i class="el-icon-trophy"></i>
            <span class="text">获奖记录</span>
          </div>
          <div class="item z-flex" @click="toUrl('/my/match')">
            <i class="el-icon-document-checked"></i>
            <span class="text">我的投稿</span>
          </div>
          <div class="item z-flex" @click="toUrl('/my/ps')">
            <i class="el-icon-picture-outline"></i>
            <span class="text">我的修图</span>
          </div>
          <div class="item z-flex" @click="toUrl('/my/order')">
            <i class="el-icon-document"></i>
            <span class="text">我的订单</span>
          </div>
          <div class="item z-flex" v-if="isPresident" @click="toUrl('/my/members')">
            <i class="el-icon-coin"></i>
            <span class="text">我的社员</span>
          </div>
          <div class="item z-flex" v-if="isPresident" @click="toUrl('/my/profit')">
            <i class="el-icon-money"></i>
            <span class="text">我的收益</span>
          </div>
          <div class="item z-flex" @click="toLogout">
            <i class="el-icon-switch-button"></i>
            <span class="text">退出登录</span>
          </div>
        </div>
      </el-popover>
      <el-button class="login" type="text" icon="el-icon-user-solid" v-else @click="toLogin">登录/注册</el-button>
    </div>
    <loginCom ref="loginCom"></loginCom>
  </div>
</template>

<script>
  import {mapState, mapActions} from "vuex";
export default {
  name: "headerCom",
  props: {
    
  },
  data() {
    return {
      isPresident: false,
      isVip: false,
      isLogin: false,
      avatar:'',
      username:'游客游客游客',
      activeNav:'',
      navList:[
        {
          id:0,
          title:'首页',
          url:'/index',
          name:'index',
        },
        {
          id:1,
          title:'获奖公布',
          url:'/prize/list',
          name:'prize',
        },{
          id:2,
          title:'摄影采风',
          url:'/caifeng/list',
          name:'caifeng',
        },{
          id:3,
          title:'五六课堂',
          url:'/course/list',
          name:'course',
        },{
          id:4,
          title:'自动投稿',
          url:'/match/list',
          name:'match',
        },{
          id:5,
          title:'人工精修',
          url:'/ps/index',
          name:'ps',
        },{
          id:6,
          title:'摄影展览',
          url:'/exhibition/list',
          name:'exhibition',
        },
      ],
    };
  },
  watch:{
    "$route": {
      immediate: true, 
      handler(newVal, oldVal) {
        let navName = newVal.path.split('/');
        this.activeNav = navName[1];
      },
    },
    "vuex_user": {
      immediate: true,
      handler(newVal, oldVal) {
        this.isLogin = this.$helper.isLogin();
        this.$axios.api.getUserIsVip({}, (res) => {
          if (res.code == 200) {
            this.isVip = res.data.isVip;
          }
        });
      },
    },
  },
  mounted() {
    if (this.$helper.isLogin()) {
      this.$refs.loginCom.getLoginUserInfo((res) => {
        if (res.proxy_match_vip == 11) {
          this.isPresident = true;
        }
      });
    }
  },
  computed: {
    ...mapState(['vuex_user'])
  },
  methods: {
    ...mapActions(['vuexUserLogin', 'vuexUserLogout', 'vuexInitLocalUser']),
    toUrl(url){
      if (url == '/my/gallery') {
        if (!this.isVip) {
          return this.$message.error("您的会员已过期！");
        }
      }
      this.$router.push({
        path:url,
      })
    },
    toLogin(){
      this.$refs.loginCom.showLoginDialog = true;
    },
    toLogout(){
      localStorage.removeItem('token');
      this.vuexUserLogout();
      this.$message.success('退出成功！');
    },
  },
};
</script>

<style lang="scss" scoped>
.header{
  width: 100%;
  height: 60px;
  padding: 0 60px;
  background: #fff;
  box-sizing: border-box;
  .logo{
    height: 44px; 
    cursor: pointer;
    margin-right: 50px;
  }
  .user{
    cursor: pointer;
    .avatar{
      width: 30px;
      height: 30px;
      object-fit: cover;
      border-radius: 100%;
      margin-right: 10px;
    }
    .username{
      max-width: 160px;
      @extend %textOverflow;
    }
    .el-icon-caret-bottom{
      margin-left: 5px;
      transition: all .6s;
    }
    &:hover{
      color: $colorMain;
      .el-icon-caret-bottom{
        transform: rotate(180deg);
      }
    }
  }
  .nav{
    .item{
      border-top: 4px solid #fff;
      cursor: pointer;
      margin: 0 10px;
      padding: 0 10px;
      color: #666;
      height: 60px;
      line-height: 56px;
      box-sizing: border-box;
      &:hover{
        border-top: 4px solid $colorMain;
        color: $colorMain;
      }
      &.active{
        border-top: 4px solid $colorMain;
        color: $colorMain;
      }
    }
  }
}
.my-menu{
  .menu-list{
    .item{
      font-size: 15px;
      padding:10px 20px 10px 10px;
      cursor: pointer;
      i{
        font-size: 20px;
      }
      .text{
        margin-left: 10px;
      }
      &:hover{
        color: $colorMain;
      }
    }
  }
}
</style>
